const HisUser = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0742 21.5391V19.5391C20.0742 18.4782 19.6528 17.4608 18.9026 16.7106C18.1525 15.9605 17.1351 15.5391 16.0742 15.5391H10.0742C9.01335 15.5391 7.99594 15.9605 7.24579 16.7106C6.49565 17.4608 6.07422 18.4782 6.07422 19.5391V21.5391"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0742 11.5391C15.2834 11.5391 17.0742 9.7482 17.0742 7.53906C17.0742 5.32992 15.2834 3.53906 13.0742 3.53906C10.8651 3.53906 9.07422 5.32992 9.07422 7.53906C9.07422 9.7482 10.8651 11.5391 13.0742 11.5391Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisUser;
